module.exports.leaderboard = {
  vi: {
    title: 'Avalon: The Resistance | Bảng xếp hạng',
    description: 'Bảng xếp hạng người chơi The Resistance: Avalon.',
    keywords: ['Bảng xếp hạng', 'Người chơi hàng đầu', 'Xếp hạng', 'Người chơi xuất sắc'],
  },
  pt: {
    title: 'Avalon: The Resistance | Classificação',
    description: "Tabela de classificação para jogadores de 'Avalon: The Resistance'",
    keywords: ['Classificação', 'Líderes', 'Melhores jogadores', 'Ranking'],
  },
  en: {
    title: 'Avalon: The Resistance | Leaderboard',
    description: "Leaderboard for players of 'Avalon: The Resistance'",
    keywords: ['Leaderboard', 'Top players', 'Ranking', 'Best players'],
  },
  ru: {
    title: 'Авалон: Сопротивление | Таблица лидеров',
    description: "Таблица лидеров для игроков в 'Авалон: Сопротивление'",
    keywords: ['Таблица лидеров', 'Лучшие игроки', 'Рейтинг', 'Топ игроков'],
  },
  'zh-TW': {
    title: '阿瓦隆：反抗勢力 | 排行榜',
    description: '『阿瓦隆：反抗勢力』玩家的排行榜',
    keywords: ['排行榜', '頂尖玩家', '排名', '最佳玩家'],
  },
  'zh-CN': {
    title: '阿瓦隆：反抗组织 | 排行榜',
    description: '《阿瓦隆：反抗组织》玩家的排行榜',
    keywords: ['排行榜', '顶尖玩家', '排名', '最佳玩家'],
  },
  es: {
    title: 'Avalon: La Resistencia | Tabla de clasificación',
    description: "Tabla de clasificación para jugadores de 'Avalon: La Resistencia'",
    keywords: ['Tabla de clasificación', 'Mejores jugadores', 'Ranking', 'Clasificación'],
  },
};
